import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'
import { colors } from '../../../utilities/colors'
import { useIsMobile } from '../../../hooks/useIsMobile'
import OrderSummary from './OrderSummary'
import PriceOptionCard from '../shared/PriceOptionCard'
import StatusBadge from '../shared/StatusBadge'
import { orderStatusColor } from '../shared/orderStatus'
import CancelOrderButton from './CancelOrderButton'

export default function OrderResult({ order }) {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const responseCache = order.attributes['response-cache']
  const priceOptionType = order.attributes['price-option']
  const amount = order.attributes['amount']
  const createdBy = order.attributes['created-by']
  const createdAt = order.attributes['created-at']
  const status = order.attributes['status']
  const priceOption = priceOptionType
    ? { type: priceOptionType, price: amount, delivery_eta: '', delivery_time: '' }
    : null

  const sanitizeLocationData = (data) => {
    if (!data) return null
    const line1 = data.address1 || data.address || ''
    const line2 = data.address2 || data.address_2 || ''
    return {
      name: data['dealer-name'] || data.name || '',
      address: [line1, line2].filter(Boolean).join(', '),
      city: data.city || '',
      state: data.state || '',
      postal_code: data.zip || data.postal_code || '',
      external_notes: data.external_notes || '',
    }
  }

  const origin = sanitizeLocationData(responseCache?.origin)
  const destination = sanitizeLocationData(responseCache?.destination)

  if (!responseCache) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" w="full" py={10}>
        <Text fontSize="sm" color={colors.grey300}>
          {t('Order details are not yet available.')}
        </Text>
      </Box>
    )
  }

  return (
    <Box display="flex" flexDirection="column" gap={5} w="full" py={2}>
      <Box>
        {(createdBy || createdAt) && (
          <Box display="flex" justifyContent="space-between" alignItems="center" px={2} gap={2} flexWrap="wrap">
            {createdBy && (
              <Text fontSize="xs" color={colors.grey300}>
                {t('Created by')}: <Text as="span" color={colors.grey100} fontWeight="medium">{createdBy}</Text>
              </Text>
            )}
            {createdAt && (
              <Text fontSize="xs" color={colors.grey300}>{createdAt}</Text>
            )}
          </Box>
        )}
        {status && (
          <Box px={2} mt={2} display="flex">
            <StatusBadge label={status} color={orderStatusColor(status)} />
          </Box>
        )}
      </Box>
      <OrderSummary
        origin={origin}
        destination={destination}
        vehicles={responseCache.vehicles || []}
      />
      {priceOption && (
        <PriceOptionCard
          option={priceOption}
          horizontalOrientation={isMobile}
          vehicleCount={responseCache.vehicles?.length || 1}
        />
      )}
      <CancelOrderButton order={order} />
    </Box>
  )
}
